import { getProps } from 'utils/global-utils';
import fetchApi from 'utils/api-utils';
const DECISION_TREE_URL = process.env.REACT_APP_DECISION_TREE_URL;

export const getQuestions = async ({
  language,
  lines = [
    {
      state: [
        {
          id: 'FIRST_QUESTION',
        },
      ],
      line_ref: '99010010',
    },
  ],
  optionSelected,
  partner_reference,
  productId = 'HMTEST',
  match = [],
}) => {
  const rs = await fetchApi(DECISION_TREE_URL, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: {
      language,
      lines,
      option_id: optionSelected,
      partner_reference,
      product_id: productId,
      match,
    },
  });
  const data = getProps(rs, 'json') && (await rs.json());
  return {
    status: rs.status,
    ok: rs.ok,
    result: data,
  };
};

export default getQuestions;
